import axios from 'axios';
import { API_URL } from '../constant';

const API_BASE_URL = API_URL || 'https://staging.api.topcoinuk.com/api';

// Create axios instance with auth headers
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const itAdminService = {
  // Get all IT admins with pagination and filters
  getAllItAdmins: async (params = {}) => {
    const response = await api.get('/superadmin/it-admins', { params });
    return response.data;
  },

  // Get specific IT admin details
  getItAdmin: async (userId) => {
    const response = await api.get(`/superadmin/it-admins/${userId}`);
    return response.data;
  },

  // Create new IT admin
  createItAdmin: async (adminData) => {
    const response = await api.post('/superadmin/it-admins', adminData);
    return response.data;
  },

  // Check email availability
  checkEmailAvailability: async (email) => {
    const response = await api.post('/superadmin/it-admins/check-email-availability', { email });
    return response.data;
  },

  // Update IT admin status
  updateItAdminStatus: async (userId, status, notes = '') => {
    const response = await api.post(`/superadmin/it-admins/${userId}/status`, { status, notes });
    return response.data;
  },

  // Reset IT admin password
  resetItAdminPassword: async (userId, password) => {
    const response = await api.post(`/superadmin/it-admins/${userId}/reset-password`, { password });
    return response.data;
  },
};
